import { FETCH_ACTIVE_STUDENT_TYPES } from '../constants/student-type';

export function fetchActiveStudentTypes() {
  return {
    type: FETCH_ACTIVE_STUDENT_TYPES,
    api: true,
    payload: {
      method: 'GET',
      url: '/students/types',
      params: { status: true }
    }
  };
}
